import React from 'react'
import styled from 'styled-components'
import useAPI from '~/prix/react/hooks/api'
import { getSuggestedQuestionsForUser } from '~/utils/shared/suggestedQuestions'

const Container = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 16px auto 0;
  padding: 12px 14px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
`

const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.darkGrey};
  margin-bottom: 8px;
`

const QuestionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

const QuestionButton = styled.button`
  width: 100%;
  text-align: left;
  padding: 8px 10px;
  border-radius: 8px;
  border: none;
  background: #f7f7f7;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.darkGrey};
  cursor: pointer;
  transition:
    background 0.15s ease,
    transform 0.05s ease;

  &:hover {
    background: #efefef;
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`

interface SuggestedQuestionsProps {
  title?: string
  onSelect: (question: string) => void
  disabled?: boolean
}

export function SuggestedQuestions({
  title = 'Perguntas que você pode fazer',
  onSelect,
  disabled = false,
}: SuggestedQuestionsProps) {
  const { context } = useAPI()
  const questions = getSuggestedQuestionsForUser(context.user)
  return (
    <Container>
      <Title>{title}</Title>
      <QuestionsList>
        {questions.map(question => (
          <QuestionButton
            key={question}
            type='button'
            onClick={() => onSelect(question)}
            disabled={disabled}
          >
            {question}
          </QuestionButton>
        ))}
      </QuestionsList>
    </Container>
  )
}
